import { Dayjs } from "dayjs"
import { IFeatureChange, IFeatureFieldChange } from "./featureChange.types"

export class FeatureChange implements IFeatureChange {
  constructor(
    public id: number,
    public featureId: number,
    public featureName: string,
    public operation: string,
    public changes: IFeatureFieldChange[],
    public changedAt: Dayjs,
  ) {}
}
